import { Factory } from "fishery"
import { Address } from "../tastyworks"

class AddressFactory extends Factory<Address> {
  uk() {
    return this.params({ country: "GBR", stateRegion: "LND" })
  }
}

export const addressFactory = AddressFactory.define(({ params }) => {
  const address = new Address()

  address.streetOne = params.streetOne ?? "771 Sunny"
  address.streetTwo = params.streetTwo ?? ""
  address.city = params.city ?? "Naperville"
  address.country = params.country ?? "USA"
  address.stateRegion = params.stateRegion ?? "IL"
  address.postalCode = params.postalCode ?? "60565"

  return address
})

export const addressFactory2 = AddressFactory.define(({ params }) => {
  const address2 = new Address()

  address2.streetOne = params.streetOne ?? "158 Dudley Rd"
  address2.streetTwo = params.streetTwo ?? ""
  address2.city = params.city ?? "Birmingham"
  address2.country = params.country ?? "GBR"
  address2.stateRegion = params.stateRegion ?? "West Midlands"
  address2.postalCode = params.postalCode ?? "B187QX"

  return address2
})
